import { render, staticRenderFns } from "./AMCView.vue?vue&type=template&id=2035db08"
import script from "./AMCView.vue?vue&type=script&lang=js"
export * from "./AMCView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports